import { render, staticRenderFns } from "./MarketThird.vue?vue&type=template&id=3f6164e9&scoped=true"
import script from "./MarketThird.vue?vue&type=script&lang=js"
export * from "./MarketThird.vue?vue&type=script&lang=js"
import style0 from "./MarketThird.vue?vue&type=style&index=0&id=3f6164e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6164e9",
  null
  
)

export default component.exports